import { useState } from "react";
import axios from "axios";
import { CreditCard, Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const T = {
  sk: ["Overenie bolo úspešné", "Na vystavenie všetkých dokumentov a zápis do Siene slávy zostáva uhradiť záverečný poplatok.", "akcia −75 %", "Zaplatiť kartou"],
  en: ["Verification successful", "To issue all documents and enter you in the Hall of Fame, the final fee remains to be paid.", "promotion −75 %", "Pay by card"],
  de: ["Prüfung erfolgreich", "Für die Ausstellung aller Dokumente und den Eintrag in die Hall of Fame ist noch die Abschlussgebühr zu zahlen.", "Aktion −75 %", "Mit Karte zahlen"],
  pl: ["Weryfikacja zakończona sukcesem", "Do wystawienia wszystkich dokumentów i wpisu do Galerii Sław pozostaje opłata końcowa.", "promocja −75 %", "Zapłać kartą"],
};

export default function FinalFeeBox({ application: a, auth, lang }) {
  const t = T[lang] || T.sk;
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  if (!a?.final_fee_amount || a.final_paid) return null;
  const pay = async () => {
    setBusy(true); setErr("");
    try { const { data } = await axios.post(`${API}/applicant/final-fee/checkout`, { origin_url: window.location.origin }, auth()); window.location.href = data.url; }
    catch (e) { setErr(e?.response?.data?.detail || "Error"); setBusy(false); }
  };
  return (
    <div className="border border-[#D4AF37]/50 bg-[#D4AF37]/5 p-6 mb-8" data-testid="final-fee-box">
      <h3 className="font-display text-xl text-white">{t[0]}</h3>
      <p className="text-white/60 text-sm mt-1">{t[1]}</p>
      <p className="mt-3 text-2xl font-semibold text-[#D4AF37]" data-testid="final-fee-amount">
        {Number(a.final_fee_amount).toFixed(2).replace(".", ",")} €
        {a.final_fee_promo && <span className="ml-3 text-sm text-white/40 line-through">200,00 €</span>}
        {a.final_fee_promo && <span className="ml-2 text-xs text-emerald-300">{t[2]}</span>}
      </p>
      <button onClick={pay} disabled={busy} data-testid="final-fee-pay" className="mt-4 inline-flex items-center gap-2 bg-[#D4AF37] text-black font-semibold px-6 py-3 text-sm hover:bg-[#F2E3C6] disabled:opacity-60">
        {busy ? <Loader2 size={15} className="animate-spin" /> : <CreditCard size={15} />} {t[3]}
      </button>
      {err && <p className="text-red-300 text-sm mt-2">{err}</p>}
    </div>
  );
}
